<template>
    <van-popup v-model="show" class="posterShareBox">
        <div class="posterBox">
            <div class="imgBox">
                <van-image lazy-load :src="img" show-loading>
                    <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
            </div>
            <img class="close" @click="closeServiceCode" :src="require('@/common/images/activeTools/icon_close.png')" alt="">
        </div>
        <div class="selectPoster">
            <div class="posterModelList">
                <div class="modelItem" v-for="(item, index) in list" :key="index" @click="selectPoster(item,index)">
                    <van-image lazy-load :src="item.backurl" show-loading>
                        <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                    </van-image>
                    <img class="select" v-if="index === select" :src="require('@/common/images/activeTools/select.png')" alt="">
                </div>
            </div>
            <p>长按保存海报，邀请好友助力</p>
        </div>
    </van-popup>
</template>
<script>
import {mapActions} from 'vuex'
import {getEventPosterList, getEventSinglePosterInfo} from 'api/activeTools'
export default {
    name: 'poster',
    data() {
        return {
            show: false,
            list: [],
            select: 0,
            eventid: '',
            img: '',
            item: '',
            activityCodeImg: ''
        }
    },
    methods: {
        open(id) {
            this.show = true
            this.eventid = id
            this.getPosterList()
        },
        closeServiceCode() {
            this.show = false
        },
        selectPoster(item, index) {
            this.select = index
            this.item = item
        },
        getPosterList() {
            this.$toast.loading('获取海报中')
            let data = {
                eventid: this.eventid
            }
            getEventPosterList({
                data: data,
                success: data => {
                    this.$toast.clear()
                    let resData = data.data.posterinfo
                    this.list = resData
                    // this.img = resData[0].backurl
                    if (this.list && this.list.length > 0) {
                        this.list[0].url = data.data.url
                        this.getPoster(0, resData[0])
                    }
                },
                error: data => {
                    this.$toast.clear()
                    this.$toast.fail(data.msg)
                }
            })
        },
        getPoster(index, item) {
            this.setLoading(true)
            let data = {
                eventid: this.eventid,
                posterid: item.posterid
            }
            getEventSinglePosterInfo({
                data: data,
                success: data => {
                    this.setLoading(false)
                    item.url = data.data.posterurl
                    this.list.splice(index, 1, item)
                    this.img = data.data.posterurl
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setDialogLogin'
        ])
    },
    watch: {
        'select': {
            handler() {
                 if(this.list && this.list.length>0){
                    if(this.list[this.select].url && this.list[this.select].url!==''){
                        this.img = this.list[this.select].url
                    }
                    else{
                        this.getPoster(this.select, this.list[this.select])
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss">
    .posterShareBox{
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.7);
        display: flex;
        flex-direction: column;
        .posterBox{
            flex: 1;
            position: relative;
            .imgBox{
                text-align: center;
                height: 100%;
                padding-bottom: 1.8rem;
                padding-top: 0.1rem;
                box-sizing: border-box;
                .van-image{
                    width: 5.3rem;
                    height: 100%;
                    .van-image__img{
                        width: 5.3rem;
                        height: auto;
                    }
                }
            }
            .close{
                width: 0.32rem;
                height: 0.32rem;
                position: absolute;
                top: 0.1rem;
                right: 0.5rem;
            }
        }
        .van-image__loading{
            background: transparent;
            height: 100%;
        }
        .selectPoster{
            position: absolute;
            bottom: 0;
            height: 1.8rem;
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            padding: 0.2rem 0.32rem 0;
            color: #409EFF;
            .posterModelList{
                display: flex;
                .modelItem{
                    width: 0.64rem;
                    height: 0.64rem;
                    border-radius: 0.08rem;
                    margin-right: 0.36rem;
                    position: relative;
                    .van-image{
                        width: 0.64rem;
                        height: 0.64rem;
                        border-radius: 0.08rem;
                        img{
                            width: 0.64rem;
                            height: 0.64rem;
                            border-radius: 0.08rem;
                        }
                    }
                    .select{
                        width: 0.16rem;
                        height: 0.16rem;
                        position: absolute;
                        right: 0.04rem;
                        bottom: 0.04rem;
                    }
                }
            }
            p{
                text-align: center;
                margin-top: 0.1rem;
                font-size: 0.32rem;
                color: #F56C6C;
                font-weight: 500;
            }
        }
        .van-image__error{
            background: transparent;
        }
    }
</style>
